import { Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataSharingService } from '../shared/data-sharing.service';
import { HttpClient } from '@angular/common/http';
import { UserAccount } from '../user-account';
import { switchMap, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-user-rating',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
  ],
  template: `
    <div *ngIf="isDropdownVisible" class="rating-container">
      <div class="star-rating">
        <mat-icon
          *ngFor="let star of stars; let i = index"
          (click)="selectRating(i + 1)"
          [class.selected]="i < rating"
        >
          star
        </mat-icon>
      </div>

      <textarea [(ngModel)]="comment" class="custom-textarea"></textarea>

      <button
        mat-button
        color="warn"
        (click)="onSubmitClick()"
        class="action-button"
      >
        Submit
      </button>

      <!-- Close Button -->
      <button mat-button color="warn" (click)="onCloseClick()">Close</button>
    </div>
  `,
  styleUrls: ['./user-rating.component.css'],
})
export class UserRatingComponent {
  rating = 0;
  isDropdownVisible = true; // Controls the visibility of the dropdown
  stars: number[] = [1, 2, 3, 4, 5];
  comment: string = '';
  private addUserRatingUrl = `${environment.baseUrl}/addUserRating`;
  @Output() closeDropdown = new EventEmitter<void>(); // Define output event
  constructor(
    private http: HttpClient,
    private dataSharingService: DataSharingService,
  ) {}

  selectRating(star: number) {
    this.rating = star;
  }

  onSubmitClick() {
    this.dataSharingService
      .getActiveUserAccount()
      .pipe(
        switchMap((currentAccount: UserAccount) => {
          const ratingData = {
            user_id: currentAccount.id,
            rating_value: this.rating,
            rating_comment: this.comment,
          };
          console.log('submitRating called', ratingData);
          return this.http.post<any>(this.addUserRatingUrl, ratingData);
        }),
        catchError((error) => {
          console.error('Error in submitRating', error);
          alert('An error occurred while submitting the rating');
          return of(error); // Return an observable with the error for further handling
        }),
      )
      .subscribe({
        next: (response) => {
          console.log('Rating submitted successfully', response);
          // alert('Rating submitted successfully');
          this.isDropdownVisible = false; // Close the dropdown on success
          this.closeDropdown.emit(); // Emit event to notify the parent
        },
        error: (error) => {
          console.error('Error while submitting rating', error);
          // alert('Failed to submit rating');
        },
        complete: () => {
          console.log('Rating submission complete');
        },
      });
  }

  onCloseClick() {
    this.isDropdownVisible = false; // Hide the dropdown
    this.closeDropdown.emit(); // Notify the parent component
  }
}
